import { render, staticRenderFns } from "./choose-photo.vue?vue&type=template&id=1c77a214&scoped=true&"
import script from "./choose-photo.vue?vue&type=script&lang=js&"
export * from "./choose-photo.vue?vue&type=script&lang=js&"
import style0 from "./choose-photo.vue?vue&type=style&index=0&id=1c77a214&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c77a214",
  null
  
)

export default component.exports